export const seoRoutesData = {
  ["/"]: {
    title:
      "Banking Software Development | Fintech Solutions | Digital Banking Solutions | Financial Business Software Application Development",
    description:
      "Discover Papaya, the next-gen fintech platform offering online banking, cards, and white-label solutions for businesses. Explore our services and partner with us!",
  },
  ["/home"]: {
    title:
      "Banking Software Development | Fintech Solutions | Digital Banking Solutions | Financial Business Software Application Development",
    description:
      "Discover Papaya, the next-gen fintech platform offering online banking, cards, and white-label solutions for businesses. Explore our services and partner with us!",
  },
  ["/about"]: {
    title:
      "Fintech Company | Financial Software Development Company | Fintech Agency",
    description:
      "Papaya is a licensed EMI based in Malta since 2012, delivering innovative and secure e-money services. Learn more about us and join our fintech journey today!",
  },
  ["/contacts"]: {
    title: "Contact Papaya | Get in Touch with Our Support Team",
    description:
      "Need assistance or have a question? Contact Papaya via phone, email, or our Malta office. Reach out now and let our team help you find the right solution!",
  },
  ["/careers"]: {
    title: "Careers at Papaya | Join Our Fintech Team",
    description:
      "Grow your career with Papaya! We're hiring creative, driven professionals to join our fintech team. Explore current job openings and apply to shape the future!",
  },
  ["/ttp"]: {
    title: "TPP Registration | Access Papaya Open Banking APIs",
    description:
      "Register as a TPP with Papaya to access PSD2-compliant APIs for AISP, PISP, and PIISP roles. Get started with our developer portal and integrate today!",
  },
  ["/online-banking"]: {
    title: "Open Banking Api | Open Finance Api | Open Banking Solutions",
    description:
      "Unlock Papaya’s PSD2-ready API and sandbox for Open Banking integration. Test, develop, and launch powerful financial tools—get started with our API now!",
  },
  ["/currency-exchanges"]: {
    title: "Currency Exchange Software | Currency Exchange Solutions",
    description:
      "Check Papaya’s live currency conversion mark-ups and make informed payments while abroad. Compare exchange rates and travel smarter with your card today!",
  },
  ["/fraud-disclaimer"]: {
    title: "Fraud Disclaimer | Stay Safe from Scams with Papaya",
    description:
      "Stay protected from fraud. Learn how to identify fake communications using Papaya’s name or logo. Read our tips and report suspicious activity right away!",
  },
  ["/open-banking-documentation"]: {
    title: "Papaya API Docs | Explore Our Open Banking Sandbox",
    description:
      "Explore Papaya’s Open Banking API docs and test in our PSD2 sandbox. Access guides, code samples, and get started building innovative financial solutions!",
  },
  ["/openbanking-terms-and-conditions"]: {
    title: "Open Banking Terms | Papaya Developer Portal Access Rules",
    description:
      "Review the Open Banking Terms to understand your rights and responsibilities on Papaya’s Developer Portal. Read carefully and register to start building today!",
  },
  ["/getting-started-guide"]: {
    title: "Getting Started | Guide to Using Papaya APIs",
    description:
      "Get started with Papaya’s Open Banking APIs in a few easy steps. Learn how to register, access the sandbox, and configure your apps. Begin your setup now!",
  },
  ["/eidas-certificate"]: {
    title:
      "Eidas Certificate | Qwac Qualified Web Authentication Certificate | Qsealc Qualified Electronic Seal Certificate",
    description:
      "Understand QWAC and QSealC certificates for secure TPP integration under eIDAS. Ensure compliance and protect your API communications—explore now!",
  },
  ["/production-environment"]: {
    title: "Production Access | Live Environment for Certified TPPs",
    description:
      "Go live with Papaya’s PSD2 APIs using your eIDAS certificates. Ensure compliance and unlock full production access—get certified and start building today!",
  },
  ["/general-information-about-the-sandbox"]: {
    title: "Sandbox Overview | Test Papaya APIs with Mock Data",
    description:
      "Test Papaya’s PSD2 APIs in a secure sandbox with mock data. Explore endpoints, simulate scenarios, and reset anytime—start developing your solution now!",
  },
  ["/availability"]: {
    title: "API Availability | 24/7 Access to Papaya Sandbox",
    description:
      "Papaya’s sandbox is available 24/7/365 for continuous testing of Open Banking services. Start integrating now and contact support for any assistance!",
  },
  ["/sca-strong-customer-authentication-methods"]: {
    title: "SCA Methods | Strong Customer Authentication by Papaya",
    description:
      "Learn how Papaya enables secure access through Redirect SCA flows. Authenticate users with confidence—implement strong customer authentication today!",
  },
  ["/security"]: {
    title: "Papaya Security | TLS-Encrypted API Connections",
    description:
      "All connections to Papaya APIs are protected with TLS 1.2+ for secure data exchange. Build with confidence—connect securely with our banking systems!",
  },
  ["/about-api"]: {
    title: "About Papaya API | RESTful PSD2 Integration Guide",
    description:
      "Explore Papaya’s RESTful API built on Berlin Group standards with full documentation and version control. Get started today and integrate with ease!",
  },
};
